<section class="inner-page-wrapper">
    <div class="mb-12 py-16 md:mb-40">
        <h1 class="text-24 leading-28 text-black md:text-center md:text-50 md:leading-58">
            Hier gibt's das passende Zubehör für Ihren Hyundai.
        </h1>
        <h2 class="text-16 leading-27 text-black md:text-center md:text-22 md:leading-28">
            {{ dealerLocationHeadline() }}
        </h2>
        <div class="mt-12 flex justify-center">
            <p [editable]="'shop.subText'" [type]="'text'" textEdit>{{ shopPageContent().subText }}</p>
        </div>
    </div>
</section>

<div class="page-middle" style="max-width: 1200px; margin: 0 auto">
    <div id="itt-sl-hpm" [attr.data-dealer-id]="shopIdentifier()" style="width: 100%" data-environment="own"></div>
</div>
